/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';

import _ = require("lodash");
import { WORKOUT_LABEL, WORKOUT_TYPES } from "../../../../containers/FitnessPlan/constants";
import { formFieldNames, ISet, IMicrocycleError } from "../../../../containers/FitnessPlan/FitnessTemplate/interface";
import CustomHeader, { ICustomHeaderInfo } from "../../../utils/CustomHeader";
import TextInput from "../../../TextInput";
import { getManagedExercise, checkForError } from "../../../../containers/FitnessPlan/FitnessTemplate/helper";
import { Droppable } from 'react-beautiful-dnd';
import { Exercise } from "../Exercise/Exercise";
import CustomSelect from "../../../CustomSelect";
import AppUtils from "../../../../utils/AppUtils";

interface IWorkoutWigetProps {
    selectedWorkoutPhase: any;
    exerciseList: any;
    addSection: (workoutPhase: string) => void;
    handleWorkoutPhaseChange: (updatedWorkoutPhase: any) => void;
    outerIndex: number;
    errorStates: IMicrocycleError[];
    isViewMode: boolean;
}

export const WorkoutPhaseWidget: React.FC<IWorkoutWigetProps> = (props: IWorkoutWigetProps) => {
    const { selectedWorkoutPhase, handleWorkoutPhaseChange, addSection, exerciseList, outerIndex, errorStates, isViewMode } = props;

    const currentMovementErrors = errorStates && errorStates.filter(errorState => errorState.workoutIndex === outerIndex)
    const handleWorkoutHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let currentItem = { ...selectedWorkoutPhase };
        if (event.target.name === formFieldNames.DURATION_IN_SECS) {
            const durationInSecs = event.target.value && (Number(event.target.value) * 60);
            currentItem[event.target.name] = durationInSecs;
        }
        else {
            currentItem[event.target.name] = event.target.value;
        }
        handleWorkoutPhaseChange(currentItem);
    }

    const handleAddExercise = () => {
        const newManagedExercise = getManagedExercise();
        const copiedManagedExercises = [...selectedWorkoutPhase.managedExercises];
        copiedManagedExercises.push(...newManagedExercise);
        handleWorkoutPhaseChange({ ...selectedWorkoutPhase, managedExercises: copiedManagedExercises });
    }

    const handleExerciseChange = (data: any, excerciseIndex: number) => {
        let copiedExercises = [...selectedWorkoutPhase.managedExercises];
        copiedExercises[excerciseIndex] = data;
        let currentItem = { ...selectedWorkoutPhase, managedExercises: copiedExercises }
        handleWorkoutPhaseChange(currentItem);
    }

    const handleDeleteExercise = (excerciseIndex: number) => {
        let copiedExercises = [...selectedWorkoutPhase.managedExercises];
        copiedExercises.splice(excerciseIndex, 1);
        let currentItem = { ...selectedWorkoutPhase, managedExercises: copiedExercises }
        handleWorkoutPhaseChange(currentItem);
    }

    const handleChangeType = (value: string, keyName: string) => {
        if (AppUtils.isDefined(value)) {
            let currentItem = { ...selectedWorkoutPhase, [keyName]: value };
            handleWorkoutPhaseChange(currentItem);
        }
    }

    const getWorkoutHeader = (workoutPhaseData: ISet) => {
        const { blockType, expectedDurationInSeconds, repetition, setType, trainerComments } = workoutPhaseData;
        const durationInMins = expectedDurationInSeconds && (expectedDurationInSeconds / 60);
        return (
            <section css={styles.workoutPhaseHeadersWrapper}>
                <div css={styles.workoutPhaseLabelWrapper}>
                    <div css={styles.verticalBar({ blockType })}></div>
                    <div css={styles.workoutPhaseLabel}>{WORKOUT_LABEL[blockType]}</div>
                </div>
                <div css={styles.workoutPhaseHeader}>
                    <CustomHeader headerInfos={[{ label: formFieldNames.SETTYPE, display: "TYPE", mandatory: true }]} rootCls="fitness-goal-header" additionalCls={checkForError(currentMovementErrors, null, formFieldNames.SETTYPE) && "mandatory-error"} />
                    <CustomSelect dropdownValues={WORKOUT_TYPES} selectedValue={setType && WORKOUT_TYPES.find(({ internalValue }) => internalValue === setType).displayValue} defaultValue="Select Type" updateDropdownValue={handleChangeType} keyName={formFieldNames.SETTYPE} className={checkForError(currentMovementErrors, null, formFieldNames.SETTYPE) && "input-error"} disabled={isViewMode} />
                </div>
                <div css={styles.workoutPhaseHeader}>
                    <CustomHeader headerInfos={[{ label: formFieldNames.DURATION_IN_SECS, display: "DURATION (in mins)" }]} rootCls="fitness-goal-header" additionalCls={checkForError(currentMovementErrors, "EITHER_OF_ONE_IN_WORKOUT_PHASE") && "mandatory-error"} />
                    <TextInput type="number" name={formFieldNames.DURATION_IN_SECS} placeholder="Value in mins" value={durationInMins} onChange={handleWorkoutHeaderChange} customClasses={checkForError(currentMovementErrors, "EITHER_OF_ONE_IN_WORKOUT_PHASE") ? "input-error" : ""} disabled={isViewMode} />
                </div>
                <div css={styles.workoutPhaseHeader}>
                    <CustomHeader headerInfos={[{ label: formFieldNames.REPITITION, display: "ROUNDS" }]} rootCls="fitness-goal-header" additionalCls={checkForError(currentMovementErrors, "EITHER_OF_ONE_IN_WORKOUT_PHASE") && "mandatory-error"} />
                    <TextInput type="number" name={formFieldNames.REPITITION} placeholder="Input Value" value={repetition} onChange={handleWorkoutHeaderChange} customClasses={checkForError(currentMovementErrors, "EITHER_OF_ONE_IN_WORKOUT_PHASE") ? "input-error" : ""} disabled={isViewMode} />
                </div>
                <div css={styles.workoutPhaseHeader}>
                    <CustomHeader headerInfos={[{ label: "trainerComments", display: "COMMENTS" }]} rootCls="fitness-goal-header" />
                    <TextInput name={formFieldNames.COMMENTS} placeholder="Input Comments" value={trainerComments} onChange={handleWorkoutHeaderChange} customClasses="workout-phase-comment" disabled={isViewMode} />
                </div>
            </section>
        )
    }

    const renderFooterSections = () => {
        return (
            <div css={styles.movementsActions}>
                <div css={styles.actionText} onClick={() => addSection(selectedWorkoutPhase.blockType)}>Add Section</div>
                <div css={styles.actionText} onClick={handleAddExercise}>Add Movement</div>
            </div>
        )
    }

    const checkForExerciseError = (label: string) => {
        if (label === "title") {
            return currentMovementErrors && currentMovementErrors.find(({ identifier }) => identifier === "EMPTY_EXERCISE") ? true : false
        }
        if (label === "reps" || label === "workoutDays") {
            return currentMovementErrors && currentMovementErrors.find(({ identifier }) => identifier === "EITHER_OF_ONE_EXERCISE_SET_INFO") ? true : false
        }
    }

    const getMovementSection = () => {
        const MovementHeaderInfos: ICustomHeaderInfo[] = [
            { label: "title", display: "TITLE", mandatory: true },
            { label: "reps", display: "REPS" },
            { label: "workoutDays", display: "TIME (in secs)" },
            { label: "weight", display: "WEIGHT" },
            { label: "exerciseComments", display: "COMMENTS" }
        ];

        return (
            <section css={styles.movementWrapper}>
                <div css={styles.movementLabel}>MOVEMENTS</div>
                <div css={styles.movementHeader}>
                    {
                        MovementHeaderInfos.map((header, index) => {
                            return (
                                <CustomHeader headerInfos={[header]} key={`${header.label}-${index}`} rootCls="movements-header" additionalCls={checkForExerciseError(header.label) && "mandatory-error"} />
                            )
                        })
                    }
                </div>
                <Droppable droppableId={`droppable_${outerIndex}_${selectedWorkoutPhase.blockType}`}>
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {
                                selectedWorkoutPhase.managedExercises && selectedWorkoutPhase.managedExercises.map((exercise: any, index: any) =>
                                    // <Draggable
                                    //     key={`exercise_${index}_${outerIndex}`}
                                    //     draggableId={`exercise_${index}_${outerIndex}`}
                                    //     index={index}
                                    // // isDragDisabled={!edit}
                                    // >
                                    //     {(provided) => (
                                    //         <div
                                    //             ref={provided.innerRef}
                                    //             {...provided.draggableProps}
                                    //             {...provided.dragHandleProps}
                                    //             key={`key_${index}`}
                                    //             style={provided.draggableProps.style}
                                    //         >
                                    <Exercise
                                        exerciseList={exerciseList}
                                        exercise={exercise}
                                        handleExerciseChange={(e) => handleExerciseChange(e, index)}
                                        handleDeleteExercise={() => handleDeleteExercise(index)}
                                        exerciseIndex={index}
                                        outerIndex={outerIndex}
                                        key={`exercise_phase_${index}_${outerIndex}_${selectedWorkoutPhase.blockType}`}
                                        errorStates={errorStates}
                                        isViewMode={isViewMode}
                                    />
                                    //     </div>
                                    // )}
                                    // {/* </Draggable> */ }
                                )
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                {!isViewMode && renderFooterSections()}
            </section >
        )
    }

    return (
        <div>
            {getWorkoutHeader(selectedWorkoutPhase)}
            {getMovementSection()}
        </div>
    )
}